<script>
import { Btn, Collapse } from "uiv";
export default {
  components: { Btn, Collapse },
  props: {
    heading: { type: String, required: true },
    icono: { type: [String, Boolean], required: false, default: false },
    total: { type: [Number, Boolean], required: false, default: false }
  },
  data() {
    return { show: true };
  },
  computed: {
    iconoClass() {
      return `mdi-${this.icono}`;
    }
  }
};
</script>

<template>
  <div class="panel panel-default">
    <div class="panel-heading" :class="(total > 0 ) ? 'has-total' : false">
      <i class="mdi" :class="iconoClass" v-if="icono"></i>
      <span v-html="heading"></span>
      <div class="total text-muted" v-if="total" v-text="'[' + total + ']'"></div>
      <btn type="link" size="xs" @click="show=!show">
        <i class="fa" :class="show ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </btn>
    </div>
    <collapse v-model="show">
      <slot />
    </collapse>
  </div>
</template>

<style lang="scss" scoped>
.panel {
  border: 0;
  position: relative;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);

  > .panel-heading {
    color: #333;
    border: 0;
    padding: 10px 27px 10px 10px;
    position: relative;
    font-size: 14px;
    font-style: normal;
    background: #ccd1d9;
    font-weight: 600;

    &.has-total {
      padding-right: 63px;
    }

    > .mdi {
      color: #848484;
      padding: 0;
      font-size: 15px;
      margin-right: 5px;
    }

    > .btn {
      right: 10px;
      color: #555;
      border: 0;
      padding: 0;
      position: absolute;
    }

    > .total {
      top: 10px;
      right: 30px;
      position: absolute;
      font-weight: 100;
    }
  }
}
</style>